module.exports = __webpack_public_path__ + "static/img/icon01.c930faf7.png";